module.exports = __webpack_public_path__ + "img/file.b99c8361.svg";